



























import Vue from "vue";
import { Component } from "vue-property-decorator";
import Tabs from "@/components/Tabs.vue";
import recordTypeList from "@/constants/recordTypeList.ts";
import dayjs from "dayjs";
import clone from "@/lib/clone.ts";

@Component({
  components: { Tabs },
})
export default class Statistics extends Vue {
  // data
  type = "-";
  recordTypeList = recordTypeList;
  // computed
  get recordList() {
    return this.$store.state.recordList;
  }
  get groupedList() {
    const { recordList } = this;
    const newList = clone(recordList).filter(
      (r: RecordItem) => r.type === this.type
    );
    if (newList.length === 0) {
      return [];
    }
    newList.sort(
      (a: RecordItem, b: RecordItem) =>
        dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf()
    );
    const result: Result = [
      { title: dayjs(newList[0].createdAt).format(), items: [newList[0]] },
    ];
    for (let i = 1; i < newList.length; i++) {
      const current = newList[i];
      const last = result[result.length - 1];
      if (dayjs(last.title).isSame(dayjs(current.createdAt), "day")) {
        last.items.push(current);
      } else {
        result.push({
          title: dayjs(current.createdAt).format(),
          items: [current],
        });
      }
    }
    result.map((group) => {
      group.total = group.items.reduce(
        (sum, item) => sum + parseFloat(item.amount),
        0
      );
    });
    return result;
  }

  get result() {
    const { recordList } = this;
    const hashTable: { [key: string]: HashTableValue } = {};
    for (let i = 0; i < recordList.length; i++) {
      const [date, time] = recordList[i].createdAt.split("T");
      hashTable[date] = hashTable[date] || { title: date, items: [] };
      hashTable[date].items.push(recordList[i]);
    }
    return hashTable;
  }

  beforeCreate() {
    this.$store.commit("fetchRecordList");
  }
  // methods
  tagString(tagList: Tag[]) {
    return tagList.length === 0
      ? "无"
      : tagList.map((item) => item.name).join(", ");
  }
  beautify(string: string) {
    const now = dayjs();
    const day = dayjs(string);
    if (day.isSame(now, "day")) {
      return "今天";
    } else if (day.isSame(now.subtract(1, "day"), "day")) {
      return "昨天";
    } else if (day.isSame(now.subtract(2, "day"), "day")) {
      return "前天";
    } else if (day.isSame(now, "year")) {
      return day.format("M月D日");
    } else {
      return day.format("YYYY年M月D日");
    }
  }
}
